"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterData = exports.getFiltering = exports.filterMetadataColumns = void 0;
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var sort_1 = require("utils/sort");
var moment = require("moment");
var filterMetadataColumns = function (allMeta, filteredMeta) {
    var metaLookup = allMeta.reduce(function (a, v, i) {
        a[v.identifier] = i;
        return a;
    }, {});
    var filteredMetaLookup = filteredMeta.reduce(function (a, v, i) {
        a[v.identifier] = i;
        return a;
    }, {});
    var results = [];
    var keys = Object.keys(metaLookup);
    for (var i = 0; i < keys.length; i++) {
        var meta = keys[i];
        if (filteredMetaLookup[meta] > -1) {
            continue;
        }
        results.push(allMeta[metaLookup[meta]]);
    }
    return results;
};
exports.filterMetadataColumns = filterMetadataColumns;
var getFiltering = function (filter) {
    if (filter === 'HIDE-EMPTY') {
        return (0, translation_1.getLocalization)('userfront/project/files/buttons/filter/hideEmptyFolders');
    }
    else if (filter === 'BOOKMARKS') {
        return (0, translation_1.getLocalization)('userfront/project/files/buttons/filter/showBookmarks');
    }
    else if (filter === 'RECENTS') {
        return (0, translation_1.getLocalization)('userfront/project/files/buttons/filter/recents');
    }
    else {
        return '';
    }
};
exports.getFiltering = getFiltering;
var filterData = function (metaDataColumns, files, sortByOptions, searchOptions, metadataList) {
    // visible columns
    var columns = metaDataColumns.reduce(function (prev, curr) {
        prev[curr.id] = curr;
        return prev;
    }, {});
    var copy = files.slice(0, files.length);
    var filtered = copy;
    var filters;
    if (sortByOptions.filters &&
        (filters = Object.entries(sortByOptions.filters)).length > 0) {
        filtered = filtered.filter(function (f) {
            if (searchOptions.toggleHideEmptyFolders && f.meta && f.meta.size === 0) {
                return false;
            }
            return filters.reduce(function (prev, current) {
                var key = current[0], value = current[1];
                var column = columns[key];
                if (prev === false) {
                    return false;
                }
                if (value && value.value !== undefined && column) {
                    if (column.type === 'text' && f.customMeta[key]) {
                        return (f.customMeta[key] || '')
                            .toString()
                            .toLowerCase()
                            .includes(value.value.toString().toLowerCase());
                    }
                    if ((column.type === 'datetime' || column.type === 'day') &&
                        f.customMeta[key]) {
                        return (moment(new Date(f.customMeta[key]), 'L').format('L') ===
                            value.value.format('L'));
                    }
                    if ((column.type === 'select' || column.type === 'dependant-select') &&
                        f.customMeta[key]) {
                        return value.value.value === f.customMeta[key];
                    }
                    if (column.type === 'checkbox') {
                        if (value.value) {
                            return !!f.customMeta[key];
                        }
                        else {
                            return !f.customMeta[key];
                        }
                    }
                    return value.value === f.customMeta[key];
                }
                return false;
            }, true);
        });
    }
    else {
        filtered = filtered.filter(function (f) {
            if (searchOptions.toggleHideEmptyFolders && f.meta && f.meta.size === 0) {
                return false;
            }
            return true;
        });
    }
    var sorted = filtered;
    if (sortByOptions.sortBy && sortByOptions.sortBy !== '') {
        var filter = metadataList.find(function (x) { return x.id === sortByOptions.sortBy; });
        if (filter) {
            sorted = filtered.sort((0, sort_1.sortFoldersAndFiles)(filter)(sortByOptions.order || 'asc'));
        }
    }
    else if (searchOptions.filtering === 'RECENTS') {
        var added = metaDataColumns.find(function (c) { return c.identifier === 'added-meta'; });
        if (added) {
            sorted = filtered.sort((0, sort_1.sortFoldersAndFiles)(added)(sortByOptions.order || 'asc'));
        }
    }
    else {
        var meta = metaDataColumns.find(function (c) { return c.identifier === 'name-meta'; });
        if (meta) {
            sorted = filtered.sort((0, sort_1.sortFoldersAndFiles)(meta)('asc'));
        }
    }
    return sorted;
};
exports.filterData = filterData;
